export const documents = {
  "Meus documentos": "Os meus documentos",
  "Pastas de documentos": "Pastas de documentos",
  "Documentos avulsos": "Documentos soltos",
  "Solicitações de documentos": "Solicitações de documentos",
  "Aqui você pode ver seus documentos salvos na nuvem pela sua empresa.": "Aqui pode ver os seus documentos guardados na nuvem pela sua empresa.",
  "Você não possui documentos solicitados pela sua empresa": "Não tem documentos solicitados pela sua empresa",
  "Status assinatura": "Estado da assinatura",
  "Todos": "Todos",
  "Não solicitado": "Não solicitado",
  "Pendente": "Pendente",
  "Assinado": "Assinado",
  "Nenhum documento encontrado": "Nenhum documento encontrado",
  "Documento": "Documento",
  "Descrição": "Descrição",
  "Assinatura": "Assinatura",
  "Data de validade": "Data de validade",
  "(Sem nome)": "(Sem nome)",
  "Ver assinatura": "Ver assinatura",
  "Envie seus documentos pendentes.": "Envie os seus documentos pendentes.",
  "Você não possui documentos cadastrados pela sua empresa": "Não tem documentos registados pela sua empresa",
  "Solicitação": "Solicitação",
  "Data Limite": "Data Limite",
  "Enviar documento: ": "Enviar documento:",
  "Faça o upload do documento solicitado.": "Faça o upload do documento solicitado.",
  "Arquivo selecionado:": "Arquivo selecionado:",
  "Excluir documento": "Excluir documento",
  "Enviar documento": "Enviar documento",
  "Selecione o arquivo": "Selecione o ficheiro",
  "ou arraste aqui": "ou arraste aqui",
  "Documento com senha": "Documento com palavra-passe",
  "Digite sua senha de acesso do aplicativo para abrir este documento": "Introduza a sua palavra-passe de acesso à aplicação para abrir este documento",
  "Sua senha": "A sua palavra-passe",
  "* Digite a sua senha": "* Introduza a sua palavra-passe",
  "Cancelar": "Cancelar",
  "Abrir": "Abrir",
  "Assinatura digital": "Assinatura digital",
  "Assinado por": "Assinado por",
  "E-mail:": "E-mail:",
  "Documento:": "Documento:",
  "ID do documento:": "ID do documento:",
  "Dados da assinatura:": "Dados da assinatura:",
  "Assinado em: ": "Assinado em:",
  "ID do aparelho: ": "ID do dispositivo:",
  "Modelo do aparelho: ": "Modelo do dispositivo:",
  "IP: ": "IP:",
  "Foto:": "Foto:",
  "Assinatura:": "Assinatura:",
  "Localização:": "Localização:",
  "Aviso!": "Aviso!",
  "Verifique se você alterou o status.": "Verifique se alterou o estado.",
  "Aviso": "Aviso",
  "Não foi possivel realizar o envio da imagem. Motivo: arquivo muito grande por favor enviar um arquivo menor que 3.5MB.": "Não foi possível realizar o envio da imagem. Motivo: ficheiro muito grande, por favor envie um ficheiro inferior a 3.5MB.",
  "Não foi possivel realizar o envio. Motivo: arquivo muito grande por favor enviar um arquivo menor que 3.5MB.": "Não foi possível realizar o envio. Motivo: ficheiro muito grande, por favor envie um ficheiro inferior a 3.5MB.",
  "Documento Enviado!": "Documento Enviado!",
  "Seu envio de documento foi salvo com sucesso!": "O seu envio de documento foi guardado com sucesso!",
  "Erro": "Erro",
  "Ocorreu um erro": "Ocorreu um erro",
  "Erro ao salvar arquivo.": "Erro ao guardar o ficheiro.",
  "Voltar": "Voltar",
  "Pesquisar": "Pesquisar",
  "Imprimir log": "Imprimir registo",
  "Assinado em:": "Assinado em:",
  "Modelo do aparelho:": "Modelo do dispositivo:",
  "IP:": "IP:",
  "Localização: ": "Localização:",
  "Fechar": "Fechar",
  "Assinar documento": "Assinar documento",
  "Entendi!": "Entendi!",
  "assinatura": "assinatura",
  "Aceite de Documento": "Aceitação de Documento",
  "Ao clicar em aceitar, você está dando ciência que comprova o recebimento deste documento.": "Ao clicar em aceitar, declara ter conhecimento e comprova o recebimento deste documento.",
  "Recusar": "Recusar",
  "Aceitar": "Aceitar"
};



// WEBPACK FOOTER //
// ./src/resources/ptPT/documents.js